import {Component, ViewChild, OnInit, Inject} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Article } from '../../shared/models/kb-articles.model';
import * as UIC from '@dds-uicore/all';
import { DatePipe } from '@angular/common'
import { NavService } from 'src/app/shared/services/nav.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalConstants } from 'src/app/shared/global-constants';
import { TextEditorComponent } from '../text-editor/text-editor.component';
import {MatDialog, MatDialogRef,  MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
export interface StatusDialogData {
  comment:string;
  status:string;
}

@Component({
  selector: 'app-kb-articles-create',
  templateUrl: './kb-articles-create.component.html',
  styleUrls: ['./kb-articles-create.component.scss'],
})
export class KbArticlesCreateComponent implements OnInit {
  contentLimit=GlobalConstants.contentLimit;
  // attachmentLimit=environment.attachmentLimitMB;
  chunkSizeMB=environment.chunkSizeMB;
  labels: any;
  mode = "create";
  private articleId: string;
  article: Article;
  isFetching: boolean = false;
  isContentFetching: boolean = false;
  form: UntypedFormGroup ;
  AttachmentPreview: string;
  submit_req: boolean = false;
  // Auto Save
  isAutoSave:boolean;
  autoSaveStatus: string="Changes Saved";
  autoSaveTime:Date = new Date();
  lastAutoSaveTime:Date = new Date();
  blobInterval:any
  enableTimer:boolean = true;
  referencePath:string =""
  // tags: any;
  startDateValue:any;
  endDateValue:any;
  // stopwords = ["0o", "0s", "3a", "3b", "3d", "6b", "6o", "a", "a1", "a2", "a3", "a4", "ab", "able", "about", "above", "abst", "ac", "accordance", "according", "accordingly", "across", "act", "actually", "ad", "added", "adj", "ae", "af", "affected", "affecting", "affects", "after", "afterwards", "ag", "again", "against", "ah", "ain", "ain't", "aj", "al", "all", "allow", "allows", "almost", "alone", "along", "already", "also", "although", "always", "am", "among", "amongst", "amoungst", "amount", "an", "and", "announce", "another", "any", "anybody", "anyhow", "anymore", "anyone", "anything", "anyway", "anyways", "anywhere", "ao", "ap", "apart", "apparently", "appear", "appreciate", "appropriate", "approximately", "ar", "are", "aren", "arent", "aren't", "arise", "around", "as", "a's", "aside", "ask", "asking", "associated", "at", "au", "auth", "av", "available", "aw", "away", "awfully", "ax", "ay", "az", "b", "b1", "b2", "b3", "ba", "back", "bc", "bd", "be", "became", "because", "become", "becomes", "becoming", "been", "before", "beforehand", "begin", "beginning", "beginnings", "begins", "behind", "being", "believe", "below", "beside", "besides", "best", "better", "between", "beyond", "bi", "bill", "biol", "bj", "bk", "bl", "bn", "both", "bottom", "bp", "br", "brief", "briefly", "bs", "bt", "bu", "but", "bx", "by", "c", "c1", "c2", "c3", "ca", "call", "came", "can", "cannot", "cant", "can't", "cause", "causes", "cc", "cd", "ce", "certain", "certainly", "cf", "cg", "ch", "changes", "ci", "cit", "cj", "cl", "clearly", "cm", "c'mon", "cn", "co", "com", "come", "comes", "con", "concerning", "consequently", "consider", "considering", "contain", "containing", "contains", "corresponding", "could", "couldn", "couldnt", "couldn't", "course", "cp", "cq", "cr", "cry", "cs", "c's", "ct", "cu", "currently", "cv", "cx", "cy", "cz", "d", "d2", "da", "date", "dc", "dd", "de", "definitely", "describe", "described", "despite", "detail", "df", "di", "did", "didn", "didn't", "different", "dj", "dk", "dl", "do", "does", "doesn", "doesn't", "doing", "don", "done", "don't", "down", "downwards", "dp", "dr", "ds", "dt", "du", "due", "during", "dx", "dy", "e", "e2", "e3", "ea", "each", "ec", "ed", "edu", "ee", "ef", "effect", "eg", "ei", "eight", "eighty", "either", "ej", "el", "eleven", "else", "elsewhere", "em", "empty", "en", "end", "ending", "enough", "entirely", "eo", "ep", "eq", "er", "es", "especially", "est", "et", "et-al", "etc", "eu", "ev", "even", "ever", "every", "everybody", "everyone", "everything", "everywhere", "ex", "exactly", "example", "except", "ey", "f", "f2", "fa", "far", "fc", "few", "ff", "fi", "fifteen", "fifth", "fify", "fill", "find", "fire", "first", "five", "fix", "fj", "fl", "fn", "fo", "followed", "following", "follows", "for", "former", "formerly", "forth", "forty", "found", "four", "fr", "from", "front", "fs", "ft", "fu", "full", "further", "furthermore", "fy", "g", "ga", "gave", "ge", "get", "gets", "getting", "gi", "give", "given", "gives", "giving", "gj", "gl", "go", "goes", "going", "gone", "got", "gotten", "gr", "greetings", "gs", "gy", "h", "h2", "h3", "had", "hadn", "hadn't", "happens", "hardly", "has", "hasn", "hasnt", "hasn't", "have", "haven", "haven't", "having", "he", "hed", "he'd", "he'll", "hello", "help", "hence", "her", "here", "hereafter", "hereby", "herein", "heres", "here's", "hereupon", "hers", "herself", "hes", "he's", "hh", "hi", "hid", "him", "himself", "his", "hither", "hj", "ho", "home", "hopefully", "how", "howbeit", "however", "how's", "hr", "hs", "http", "hu", "hundred", "hy", "i", "i2", "i3", "i4", "i6", "i7", "i8", "ia", "ib", "ibid", "ic", "id", "i'd", "ie", "if", "ig", "ignored", "ih", "ii", "ij", "il", "i'll", "im", "i'm", "immediate", "immediately", "importance", "important", "in", "inasmuch", "inc", "indeed", "index", "indicate", "indicated", "indicates", "information", "inner", "insofar", "instead", "interest", "into", "invention", "inward", "io", "ip", "iq", "ir", "is", "isn", "isn't", "it", "itd", "it'd", "it'll", "its", "it's", "itself", "iv", "i've", "ix", "iy", "iz", "j", "jj", "jr", "js", "jt", "ju", "just", "k", "ke", "keep", "keeps", "kept", "kg", "kj", "km", "know", "known", "knows", "ko", "l", "l2", "la", "largely", "last", "lately", "later", "latter", "latterly", "lb", "lc", "le", "least", "les", "less", "lest", "let", "lets", "let's", "lf", "like", "liked", "likely", "line", "little", "lj", "ll", "ll", "ln", "lo", "look", "looking", "looks", "los", "lr", "ls", "lt", "ltd", "m", "m2", "ma", "made", "mainly", "make", "makes", "many", "may", "maybe", "me", "mean", "means", "meantime", "meanwhile", "merely", "mg", "might", "mightn", "mightn't", "mill", "million", "mine", "miss", "ml", "mn", "mo", "more", "moreover", "most", "mostly", "move", "mr", "mrs", "ms", "mt", "mu", "much", "mug", "must", "mustn", "mustn't", "my", "myself", "n", "n2", "na", "name", "namely", "nay", "nc", "nd", "ne", "near", "nearly", "necessarily", "necessary", "need", "needn", "needn't", "needs", "neither", "never", "nevertheless", "new", "next", "ng", "ni", "nine", "ninety", "nj", "nl", "nn", "no", "nobody", "non", "none", "nonetheless", "noone", "nor", "normally", "nos", "not", "noted", "nothing", "novel", "now", "nowhere", "nr", "ns", "nt", "ny", "o", "oa", "ob", "obtain", "obtained", "obviously", "oc", "od", "of", "off", "often", "og", "oh", "oi", "oj", "ok", "okay", "ol", "old", "om", "omitted", "on", "once", "one", "ones", "only", "onto", "oo", "op", "oq", "or", "ord", "os", "ot", "other", "others", "otherwise", "ou", "ought", "our", "ours", "ourselves", "out", "outside", "over", "overall", "ow", "owing", "own", "ox", "oz", "p", "p1", "p2", "p3", "page", "pagecount", "pages", "par", "part", "particular", "particularly", "pas", "past", "pc", "pd", "pe", "per", "perhaps", "pf", "ph", "pi", "pj", "pk", "pl", "placed", "please", "plus", "pm", "pn", "po", "poorly", "possible", "possibly", "potentially", "pp", "pq", "pr", "predominantly", "present", "presumably", "previously", "primarily", "probably", "promptly", "proud", "provides", "ps", "pt", "pu", "put", "py", "q", "qj", "qu", "que", "quickly", "quite", "qv", "r", "r2", "ra", "ran", "rather", "rc", "rd", "re", "readily", "really", "reasonably", "recent", "recently", "ref", "refs", "regarding", "regardless", "regards", "related", "relatively", "research", "research-articl", "respectively", "resulted", "resulting", "results", "rf", "rh", "ri", "right", "rj", "rl", "rm", "rn", "ro", "rq", "rr", "rs", "rt", "ru", "run", "rv", "ry", "s", "s2", "sa", "said", "same", "saw", "say", "saying", "says", "sc", "sd", "se", "sec", "second", "secondly", "section", "see", "seeing", "seem", "seemed", "seeming", "seems", "seen", "self", "selves", "sensible", "sent", "serious", "seriously", "seven", "several", "sf", "shall", "shan", "shan't", "she", "shed", "she'd", "she'll", "shes", "she's", "should", "shouldn", "shouldn't", "should've", "show", "showed", "shown", "showns", "shows", "si", "side", "significant", "significantly", "similar", "similarly", "since", "sincere", "six", "sixty", "sj", "sl", "slightly", "sm", "sn", "so", "some", "somebody", "somehow", "someone", "somethan", "something", "sometime", "sometimes", "somewhat", "somewhere", "soon", "sorry", "sp", "specifically", "specified", "specify", "specifying", "sq", "sr", "ss", "st", "still", "stop", "strongly", "sub", "substantially", "successfully", "such", "sufficiently", "suggest", "sup", "sure", "sy", "system", "sz", "t", "t1", "t2", "t3", "take", "taken", "taking", "tb", "tc", "td", "te", "tell", "ten", "tends", "tf", "th", "than", "thank", "thanks", "thanx", "that", "that'll", "thats", "that's", "that've", "the", "their", "theirs", "them", "themselves", "then", "thence", "there", "thereafter", "thereby", "thered", "therefore", "therein", "there'll", "thereof", "therere", "theres", "there's", "thereto", "thereupon", "there've", "these", "they", "theyd", "they'd", "they'll", "theyre", "they're", "they've", "thickv", "thin", "think", "third", "this", "thorough", "thoroughly", "those", "thou", "though", "thoughh", "thousand", "three", "throug", "through", "throughout", "thru", "thus", "ti", "til", "tip", "tj", "tl", "tm", "tn", "to", "together", "too", "took", "top", "toward", "towards", "tp", "tq", "tr", "tried", "tries", "truly", "try", "trying", "ts", "t's", "tt", "tv", "twelve", "twenty", "twice", "two", "tx", "u", "u201d", "ue", "ui", "uj", "uk", "um", "un", "under", "unfortunately", "unless", "unlike", "unlikely", "until", "unto", "uo", "up", "upon", "ups", "ur", "us", "use", "used", "useful", "usefully", "usefulness", "uses", "using", "usually", "ut", "v", "va", "value", "various", "vd", "ve", "ve", "very", "via", "viz", "vj", "vo", "vol", "vols", "volumtype", "vq", "vs", "vt", "vu", "w", "wa", "want", "wants", "was", "wasn", "wasnt", "wasn't", "way", "we", "wed", "we'd", "welcome", "well", "we'll", "well-b", "went", "were", "we're", "weren", "werent", "weren't", "we've", "what", "whatever", "what'll", "whats", "what's", "when", "whence", "whenever", "when's", "where", "whereafter", "whereas", "whereby", "wherein", "wheres", "where's", "whereupon", "wherever", "whether", "which", "while", "whim", "whither", "who", "whod", "whoever", "whole", "who'll", "whom", "whomever", "whos", "who's", "whose", "why", "why's", "wi", "widely", "will", "willing", "wish", "with", "within", "without", "wo", "won", "wonder", "wont", "won't", "words", "world", "would", "wouldn", "wouldnt", "wouldn't", "www", "x", "x1", "x2", "x3", "xf", "xi", "xj", "xk", "xl", "xn", "xo", "xs", "xt", "xv", "xx", "y", "y2", "yes", "yet", "yj", "yl", "you", "youd", "you'd", "you'll", "your", "youre", "you're", "yours", "yourself", "yourselves", "you've", "yr", "ys", "yt", "z", "zero", "zi", "zz"]
  status: string;
  message= "Hello";
  endDateError: string;
  RoleName:string;
  fileReplacement: boolean = false;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  Public = GlobalConstants.Public;
  Restricted = GlobalConstants.Restricted;
  AttchStatusCreate = GlobalConstants.AttchStatusCreate;
  AttchStatusDelete = GlobalConstants.AttchStatusDelete;
  AttchStatusUpdate = GlobalConstants.AttchStatusUpdate;
  htmlContent: string;
  savedContent: string="";
  contentToSaveReceivedFromChild: string;
  contentRec:string="";
  @ViewChild(TextEditorComponent) textEditorComponent: TextEditorComponent;
  AttachmentURL: string;
  docdata: string="";
  existingDocUrl: string;
  isExistingDocRemoved:boolean=false;
  ArticleSizeExceeded: boolean;
  percentage: number;
  isAttachmentUploading: boolean;
  startDateError: string;
  constructor(private datePipe: DatePipe,private authService:AuthService,public dialog: MatDialog, 
    private navService: NavService, private commonService: CommonService, public route: ActivatedRoute,
     private router: Router,public sanitizer: DomSanitizer) { }

  openDialog(statusRec): void {
    if(this.isSubmissionValid()==false){
      return;
    }
    const dialogRef = this.dialog.open(StatusPopupCreate, {
      data: {comment: '',status:statusRec}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.click){
        this.onSaveArticle(statusRec,result.comment)
      }
    });
  }

  setArticle(data){
    this.article={
      Id:this.articleId,
      Title:data.Title,
      Content:data.Content,
      AttachmentId:data.AttachmentId,
      Status:data.Status,
      Accesslevel:data.Accesslevel,
      PublisherName:data.PublisherName,
      ScheduledStartDate:data.ScheduledStartDate,
      ScheduledEndDate:data.ScheduledEndDate,
      Comments:data.Comments
    }
    if(this.article.AttachmentId){
      if(this.commonService.localArticle && this.commonService.localArticle[this.articleId]?.AttachmentUrl){
        let data=this.commonService.localArticle[this.articleId];
        this.article.AttachmentUrl=data.AttachmentUrl;
        this.form.setValue({
          Title: this.article.Title,
          AttachmentUrl: this.article.AttachmentUrl,
          // tags: this.article.tags.join(' '),
          Accesslevel:this.article.Accesslevel,
          ScheduledStartDate:this.DefaultStartDate(this.article.ScheduledStartDate),
          ScheduledEndDate:this.datePipe.transform(this.article.ScheduledEndDate, 'MM/dd/yyyy'),
        })
        if(this.article?.Content)
            this.savedContent = this.article?.Content;
        this.isFetching = false;
        this.existingDocUrl=this.article.AttachmentUrl;
      }
      else{
        this.commonService.fetchAttachment(this.article.AttachmentId[0]).subscribe(
          result=>{
          if(result.Status=="Failure"){
            this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
            this.router.navigate['/home'];
            return;
          }
          this.article.AttachmentUrl=result.data.AttachmentUrl;
          this.form.setValue({
            Title: this.article.Title,
            AttachmentUrl: this.article.AttachmentUrl,
            // tags: this.article.tags.join(' '),
            Accesslevel:this.article.Accesslevel,
            ScheduledStartDate:this.DefaultStartDate(this.article.ScheduledStartDate),
            ScheduledEndDate:this.datePipe.transform(this.article.ScheduledEndDate, 'MM/dd/yyyy'),
          })
          if(this.article?.Content)
             this.savedContent = this.article?.Content;
          this.isFetching = false;
          this.existingDocUrl=this.article.AttachmentUrl;
          this.checkStartDates(this.form.value.ScheduledStartDate);
          this.checkEndDates(this.form.value.ScheduledEndDate);
          }
        )
      }
    }
    else{
      this.form.setValue({
        Title: this.article.Title,
        AttachmentUrl: null,
        // tags: this.article.tags.join(' '),
        Accesslevel:this.article.Accesslevel,
        ScheduledStartDate: this.DefaultStartDate(this.article.ScheduledStartDate),
        ScheduledEndDate:this.datePipe.transform(this.article.ScheduledEndDate, 'MM/dd/yyyy'),
      })
      this.savedContent = this.article?.Content;
      this.isFetching = false;
      this.existingDocUrl=null;
      this.checkStartDates(this.form.value.ScheduledStartDate);
      this.checkEndDates(this.form.value.ScheduledEndDate);
    }
  }

  DefaultStartDate(startDate):any{
    let defaultStartDate,today;
    defaultStartDate= this.datePipe.transform(startDate, 'MM/dd/yyyy');
    today = moment().format("MM/DD/YYYY").toString();
    if(moment(defaultStartDate).isBefore(today)){ //If startDate is less than today, then it is defaulted otherwise left
        defaultStartDate=today;
        this.commonService.setNotification("StartDate has been updated to current date as it cannot be less than the current date!","Information");
        }
    return defaultStartDate;
  }
  ngOnInit(): void {

    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName=nextValue.RoleName;

    });


    this.form = new UntypedFormGroup({
      'Title': new UntypedFormControl(null, {
        validators: [Validators.required]
      }),

      'AttachmentUrl': new UntypedFormControl(null, {
        // asyncValidators: [mimeType] //mimeType is a custom validator for types of file uploaded
      }),
      // 'tags': new FormControl(null, {
      //   validators: [Validators.required]
      // }),
      'Accesslevel': new UntypedFormControl(null, {
        validators: [Validators.required]
      }),
      'ScheduledStartDate': new UntypedFormControl(this.datePipe.transform(Date.now(), 'MM/dd/yyyy'), {
      validators: [Validators.required]
      }),
      'ScheduledEndDate': new UntypedFormControl(null, {
      }),
      // 'comments': new FormControl(null, {
      // })
    })



    // dds upload
    var allowedExensions = ["pdf","png","jpg","jpeg"];
   let afterDelete = () => {
     this.form.patchValue({AttachmentUrl:null});
     this.fileReplacement=false;
     this.AttachmentPreview='';
     this.AttachmentURL='';

   }
   // Disallowed extension file message
    var extensionErrorMessage = "The specified file cannot be uploaded. Only files with the following extensions are allowed - {extensions}.";
    // File maximum size message
    var sizeErrorMessage = "The specified file cannot be uploaded. Only files smaller than {max-size} are allowed.";
    [].forEach.call(document.querySelectorAll("[ id=\"uploadInput\"]"), function(element) {
      new UIC.FileUpload(element, {
        allowedExensions,
        afterDelete,
        extensionErrorMessage,
        sizeErrorMessage
      });
    });



 [].forEach.call(document.querySelectorAll("[data-target=\"#StartDateCalender\"]"), function (element) {
  new UIC.DatePicker(element, {
     selector: "#StartDateCalender",
      defaultDate: Date.now(),
      datesFilter: true,
      pastDates: false,
     notBeforeDate: Date.now()-24*60*60*1000 //yesterday
    });
 });

    // [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__datepicker\"]"), function (element) {
    [].forEach.call(document.querySelectorAll("[data-target=\"#EndDateCalender\"]"), function (element) {
    new UIC.DatePicker(element, {
        selector: "#EndDateCalender",
        defaultDate: null,
        datesFilter: true,
        pastDates: false,
       notBeforeDate: Date.now()-24*60*60*1000 //yesterday
      });
    });

    //dds form
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__form-validation\"]"), function (element) {
      new UIC.Form(element, { validate: "true" });
    });
    //tags
    [].forEach.call(document.querySelectorAll("[data-toggle='dds__filter-collection']"), function (element) {
      var filter = new UIC.FilterCollection(element);

    });
    //datepicker
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__datepicker\"]"), function (element) { new UIC.DatePicker(element, { selector: "#myCalendar", defaultDate: "10/09/2020", datesFilter: true, availableWeekDays: [{ day: 'monday' }, { day: 'tuesday' }, { day: 'wednesday' }, { day: 'thursday' }, { day: 'friday' }], pastDates: true, notBeforeDate: new Date("09/01/2020"), notAfterDate: "02/02/2021" }); });

    //toggle
    [].forEach.call(document.querySelectorAll("[data-toggle=\"dds__button\"]"), function(element) {
      new UIC.Button(element);
  });


    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.has('articleId')) {
        this.articleId = paramMap.get('articleId');
        this.fetchFileReferncePath(paramMap.get('navUrl'),this.articleId);
        this.isFetching = true;
        this.mode = 'edit';


        if(this.commonService.localArticle[this.articleId]){
          let data=this.commonService.localArticle[this.articleId];
          //console.log("data",data);
          this.setArticle(data);
        }
        else{
          this.commonService.fetchOneArticle(this.articleId).subscribe(
            articleData => {
              if(articleData.Status=="Failure"){
                this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
                this.router.navigate['/home'];
              }
              let data = articleData.data;
              this.setArticle(data);
            });
        }
      }
      else {
        this.fetchFileReferncePath(paramMap.get('navUrl'),0);
        this.mode = 'create';
        this.articleId = null;
        this.isAutoSave =true;
      }
    })

  }

  ngOnDestroy(){
    if(this.blobInterval){
      //console.log('clean the blob interval');
      clearInterval(this.blobInterval);
    }
  }

  htmlContentChangeEventFunction(data){
    //console.log(data);
    if(this.isAutoSave){
    this.terminateblobServiceCall();
    }
    else{    clearInterval(this.blobInterval);}
  }
  // checkIsAutoSave(){
  //   console.log(this.isAutoSave)
  //   this.isAutoSave=true;
  //   document.getElementsByClassName("dds__btn-toggle-container dds__btn-toggle")[0]["ariaChecked"]
  //   document.getElementsByClassName("dds__toggle-circle")[0]["style"]="transform: translateX(66.0875px)";
  //   return true;
  // }
  // checkIsAutoSavehidden(){
  //   return false;
  // }

 fetchFileReferncePath(path,articleId){
  this.isContentFetching = true;
  this.commonService.fetchFileContentReferencePath(path,articleId).subscribe(res=>{
    let autosave = res.data['autoSave']
    this.referencePath = res.data['fileContentReferencePath'];

    document.getElementsByClassName("dds__btn-toggle-container dds__btn-toggle")[0]["ariaChecked"] = autosave;
    if(autosave){
      document.getElementsByClassName("dds__toggle-circle")[0]["style"]="transform: translateX(66.0875px)";
    }
    else{
      document.getElementsByClassName("dds__toggle-circle")[0]["style"]="transform: translateX(0px)";
    }
    this.isAutoSave =autosave;
    //console.log(this.isAutoSave);
    if(res.data['fileContent']){
        this.savedContent = res.data['fileContent'];
        this.textEditorComponent?.transmitContentToSave(this.savedContent);
        this.contentRec = this.savedContent;
    }
    else{
      this.savedContent="";
      this.textEditorComponent?.transmitContentToSave(this.savedContent);
    }
    //console.log("s",this.savedContent)
    this.isContentFetching = false;
  });
  clearInterval(this.blobInterval);
 }
 GetIdleTime(){
  return moment.duration(moment(this.lastAutoSaveTime).diff(moment(this.autoSaveTime))).asSeconds();
 }
  receiveContentFromEditor(data) {
    this.autoSaveTime = new Date();
    this.contentRec = data;
    const byteSize = str => new Blob([str]).size;
    if(byteSize(this.contentRec)>this.contentLimit*1048576){
      this.commonService.setNotification("Article Content cannot be greater than 20MB.","Error");
      this.ArticleSizeExceeded=true;
    }
    else{
      this.ArticleSizeExceeded=false;
  }
  if(this.enableTimer && this.isAutoSave){
    this.blobInterval = setInterval(() => {
      //console.log('my timer enable',new Date().toLocaleTimeString());
      this.blobServicecall();
    }, 10000);
    this.enableTimer =false;
    }
  }
 enableAutoSave(){

    if(this.isAutoSave){
      document.getElementsByClassName("dds__toggle-circle")[0]["style"]="transform: translateX(66.0875px)";
      this.isAutoSave = false;
    }
    else{
      document.getElementsByClassName("dds__toggle-circle")[0]["style"]="transform: translateX(0px)";
      this.isAutoSave = true;
    }

  }
  blobServicecall(){
    //console.log(this.ArticleSizeExceeded,this.referencePath,'blob interval',this.blobInterval)
    if(this.GetIdleTime() < 10 && !this.ArticleSizeExceeded){
      //console.log('Blob service call');
    this.autoSaveStatus = "Saving Article Content Changes";
    this.commonService.updateFileContent(this.referencePath,this.contentRec,this.articleId?parseInt(this.articleId):0).subscribe(res=>{
    this.autoSaveStatus = "Article Content Changes Saved";
    this.commonService.localArticle[this.articleId].Content=this.contentRec;
    })
    }
    //console.log(this.GetIdleTime());
    this.lastAutoSaveTime = new Date();
  }

  terminateblobServiceCall() {
    clearInterval(this.blobInterval);
    this.enableTimer = true;
    //console.log('my clear timer enable',this.enableTimer);
    this.blobServicecall();


  }
  checkStartDates(startdate){
    let today = moment().format("MM/DD/YYYY").toString();
    if(!moment(startdate).isValid()) //Check to be applied whether or not startDate is emtpy
        this.startDateError="Please choose a valid Start Date";
    else if(moment(startdate).isBefore(today))
        this.startDateError="Start Date cannot be less than the current date! ";
    else
        this.startDateError=null;
  }
  checkEndDates(enddate){
    let today = moment().format("MM/DD/YYYY").toString();
    if(enddate && !moment(enddate).isValid()){ //Check is only applied if enddate is present. If enddate is not present, its a correct case
      this.endDateError="Please choose a valid End Date";}
    else if(enddate && moment(enddate).isBefore(today)) //Check is only applied if enddate is present
        this.endDateError="End Date cannot be less than the current date!";
    else
        this.endDateError=null; //If end date is removed or not present, no error should be there
  }
  startDateChange(e){
    this.checkStartDates(e.target.value);
    this.form.get('ScheduledStartDate').setValue(e.target.value);

  }
  endDateChange(e){
    this.checkEndDates(e.target.value);
    this.form.patchValue({
         ScheduledEndDate: e.target.value
    })
  }
  SanitizeData(data:any){
    return this.sanitizer.bypassSecurityTrustHtml(data);
      }


  backBtn(){
    let transferUrl;
    if(this.mode=='edit')
       transferUrl = this.router.url.replace('/edit/','/');
    else if(this.mode=='create')
       transferUrl= '/';
    this.router.navigateByUrl(transferUrl);
  }

  onDocPicked(event: Event) {
    if (event) {
      let extensions=['application/pdf','image/png','image/jpg','image/jpeg']; //This extra check is required since DDS simply gives a warning but do not restrict the users from uploading restricted extensions
      const inputElement = event.target as HTMLInputElement
       let uploadDiv= document.getElementById('uploadInputDiv').getElementsByClassName('dds__form-upload-target')[0] as HTMLElement;
       let loopFile = (fileIndex: number) => {
        const file = inputElement.files[fileIndex];
        const reader = new FileReader();
        let extension=file.type.substring(file.type.lastIndexOf('/') + 1);
        let fileReference=Date.now() + '' +  Math.random();
        const chunkSize = this.chunkSizeMB*1048576 ;
        let chunkIndex = 0;
        let totalChunks=Math.ceil(file.size / chunkSize);
        this.percentage = Math.trunc(chunkIndex / totalChunks * 100);
        // if (extensions.includes(file.type) && file.size < this.attachmentLimit* 1048576)  {
        if (extensions.includes(file.type))  {
          reader.onload =  () => {
            let loop = (offset: number) => {
              chunkIndex++;
              const chunk = file.slice(offset, offset + chunkSize);
              this.isAttachmentUploading = true;
              this.commonService.sendChunk(chunk, chunkIndex, totalChunks, fileReference, extension, file.type).subscribe(
                (res) => {
                  if(res.Status=="Failure"){
                    this.form.patchValue({AttachmentUrl:null});
                    this.AttachmentPreview='';
                    this.AttachmentURL='';
                    this.fileReplacement=false;
                    uploadDiv.classList.add('dds__d-none'); //Hiding the Upload Target
                    this.commonService.setNotification("Something went wrong! Please try again in some time.","Error");
                    this.isAttachmentUploading=false;
                    fileIndex++;
                    if(fileIndex < inputElement.files.length)
                      loopFile(fileIndex);
                    return;
                  }
                  this.percentage = Math.trunc(chunkIndex / totalChunks * 100);
                  if (chunkIndex==totalChunks){
                    this.isAttachmentUploading = false;
                    this.fileReplacement=true;
                    this.AttachmentPreview = reader.result as string;
                    this.form.patchValue({ AttachmentUrl: res.data }); //SaasURI of PDF
                    this.AttachmentURL = window.URL.createObjectURL(file);
                    this.docdata ='<iframe src=' +this.AttachmentURL+ ' frameborder="0" ></iframe>';
                    uploadDiv.classList.remove('dds__d-none');
                    fileIndex++;
                    if(fileIndex < inputElement.files.length)
                      loopFile(fileIndex)
                  }
                  offset += chunkSize;
                  if (offset < file.size) {
                    loop(offset)
                  }
                })
            }
            loop(0);
          }
        }
        else {
          uploadDiv.classList.add('dds__d-none'); //Hiding the Upload Target
          this.form.patchValue({AttachmentUrl:null});
          this.AttachmentPreview='';
          this.AttachmentURL='';
          this.fileReplacement=false;
          this.commonService.setNotification("The specified file cannot be uploaded. Files with following extensions - pdf, jpg, jpeg, png are allowed.","Error");
          fileIndex++;
          if(fileIndex < inputElement.files.length)
            loopFile(fileIndex);
        }
        reader.readAsDataURL(file);
      }
      loopFile(0)
    }
  }
  removeExistingDoc(){
    if(this.fileReplacement==false){ //Form value need not to be changed to empty string if some other new fileRepalcement is being done
      this.fileReplacement=true;
      // this.form.patchValue({AttachmentUrl:''})
    }
    this.isExistingDocRemoved=true;
    this.existingDocUrl='';
  }
//ALL TAGS FUNCTIONS
// remove_stopwords(str) {
//   let res = []
//   let words = str.split(' ')
//   for (let i = 0; i < words.length; i++) {
//     let word_clean = words[i].split(".").join("") //if the word contain '.'
//     if (!this.stopwords.includes(word_clean)) {
//       res.push(word_clean)
//     }
//   }
//   return (res.join(' '))
// }
  // trimContent(s) {
  //   return s.replace(/<\/?[^>]+(>|$)+/ig, "").replace(/&nbsp;/g, '')
  // }
  // onlyUnique(value, index, self) {
  //   return self.indexOf(value) === index;
  // }
  // removeTag(str, tagstr) {
  //   if (!(tagstr[0] == ' ' && tagstr[tagstr.length - 1] == ' '))
  //     tagstr = ' ' + tagstr + ' ';
  //   let tagsStrToDisplay = tagstr.replace(' ' + str + ' ', ' ');
  //   if (!tagsStrToDisplay.replace(/\s/g, '').length) {
  //     tagsStrToDisplay = '';
  //   }
  //   this.form.controls.tags.setValue(tagsStrToDisplay);
  // }
  // addSuggestedTag(str, tagstr) {
  //   let tagsStrToDisplay;
  //   if (tagstr)
  //     tagsStrToDisplay = tagstr + ' ' + str;
  //   else
  //     tagsStrToDisplay = str;
  //   this.form.controls.tags.setValue(tagsStrToDisplay);
  // }
  // tagsArr() {
  //   let tagsToDisplay;
  //   if (this.form.value['tags']) {
  //     tagsToDisplay = (this.form.value['tags'].toLowerCase().split(/[ ]+/)).filter(function (el) {
  //       return el;
  //     });
  //     tagsToDisplay = tagsToDisplay.filter(function (el) {
  //       return el != '';
  //     })
  //       .filter(this.onlyUnique)
  //   }
  //   return tagsToDisplay;
  // }
  // suggestedTags() {
  //   let sugsTagsFromTitle, sugsTagsFromContent, sugsTagsToDisplay;
  //   if (this.form.value['Title'])
  //     sugsTagsFromTitle = this.remove_stopwords(this.form.value['Title']).toLowerCase().split(/[ ]+/);

  //   if (this.form.value['content']) {
  //     let recommendation = ['python', 'analysis', 'middleware', 'soa', 'fcc', 'cicd', 'documentation', 'deployment', 'training', 'testing', 'devops', 'ado', 'flask', 'defect', 'git', 'azure']
  //     sugsTagsFromContent = (this.trimContent(this.form.value['content']).toLowerCase().split(/[ ]+/)).filter(function (el) {
  //       if (recommendation.includes(el))
  //         return el;
  //     });
  //   }

  //   if (sugsTagsFromContent && sugsTagsFromTitle)
  //     sugsTagsToDisplay = (sugsTagsFromTitle.concat(sugsTagsFromContent));
  //   else if (sugsTagsFromTitle)
  //     sugsTagsToDisplay = sugsTagsFromTitle;
  //   else
  //     sugsTagsToDisplay = sugsTagsFromContent;
  //   sugsTagsToDisplay = sugsTagsToDisplay.filter(function (el) {
  //     return el != '';
  //   })
  //     .filter(this.onlyUnique)
  //   return sugsTagsToDisplay
  // }

  isSubmissionValid(){
    if(!moment(this.form.value.ScheduledStartDate).isValid()){//Trigger an error if Startdate is empty or invalid (both taken care by moment isValid)
      this.startDateError="Please choose a valid Start Date";
      return false;}
    if(this.form.value.ScheduledEndDate && !moment(this.form.value.ScheduledEndDate).isValid()){ //Check only if Enddate is entered
      this.endDateError="Please choose a valid End Date";
      return false;}
    if (this.form.value.ScheduledStartDate && (Date.parse(this.form.value.ScheduledEndDate) < Date.parse(this.form.value.ScheduledStartDate))) {
      this.endDateError="Start Date cannot be greater than End Date!";
      return false;
    }
    let today = moment().format("MM/DD/YYYY").toString();
    if(this.form.value.ScheduledEndDate && moment(this.form.value.ScheduledEndDate).isBefore(today)){
      this.endDateError="End Date cannot be less than the current date!";
      return false;
    }
    if(this.form.value.ScheduledStartDate && moment(this.form.value.ScheduledStartDate).isBefore(today)){
      this.startDateError="Start Date cannot be less than the current date!";
      return false;
    }
    //get the data from the child component
    this.textEditorComponent.emitContentToSave();
    const byteSize = str => new Blob([str]).size;
    this.submit_req = true;
    if (this.form.invalid ||  this.contentRec==""  || byteSize(this.contentRec)>this.contentLimit*1048576) {
      return false;
    }
    return true;
  }
  onSaveArticle(status,comments) {
    clearInterval(this.blobInterval);
    //set tags
    // this.tags = this.form.value['tags'] && (this.form.value['tags'].toLowerCase().split(/[ ]+/)).filter(function (el) {
    //   return el;
    // });
    if(!status)
      status=this.Drafted;
    else if(status==this.Deleted)
      status=this.Drafted;

     if(this.isSubmissionValid()==false){
      return;
    }
    this.isFetching = true;//no need to close this spinner as we are changing the page to publish COMPONENT already
    let folderId=this.navService.findFolderID(this.route.snapshot.url)
    if (this.mode == 'create') { //CREATE MODE
      let AttachmentStatus=this.form.value.AttachmentUrl?this.AttchStatusCreate:null;
      this.commonService.addArticles(this.form.value.Title, this.contentRec, this.form.value.AttachmentUrl,AttachmentStatus, this.router.url.substring(1), status,this.form.value.Accesslevel,this.form.value.ScheduledStartDate,this.form.value.ScheduledEndDate,folderId,this.RoleName==this.Moderator?comments:null,this.isAutoSave);
    }
    else {  //EDIT OR UPDATE MODE
      //Attachment
      let AttachmentStatus,contentUploading;
      if(this.isExistingDocRemoved)
          AttachmentStatus=this.AttchStatusDelete;
      else{
          if(this.fileReplacement){
            if(this.article.AttachmentId)
              AttachmentStatus=this.AttchStatusUpdate;
            else
            AttachmentStatus=this.AttchStatusCreate;
          }
          else
            AttachmentStatus=null;
      }
      // //Content
      let IsContentSame = this.contentRec.normalize() === this.article.Content.normalize();
      contentUploading=IsContentSame?null:this.contentRec;


      this.commonService.updateArticles(this.article.Id,this.form.value.Title, contentUploading, 
        this.form.value.AttachmentUrl, AttachmentStatus,this.article.AttachmentId?this.article.AttachmentId[0]:0, 
        this.router.url.substring(1), status,this.form.value.Accesslevel,this.form.value.ScheduledStartDate,
        this.form.value.ScheduledEndDate,folderId,this.RoleName==this.Moderator?comments:null,this.isAutoSave);
     // this.commonService.getNavList();
   }
    this.form.reset();
  }
}

@Component({
  selector: 'status-popup',
  templateUrl: 'popup-kb-articles-create.html',
  styleUrls: ['./kb-articles-create.component.scss'],
})
export class StatusPopupCreate {
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  clicked:boolean=false;
  constructor(
    public dialogRef: MatDialogRef<StatusPopupCreate>,private router:Router,
    @Inject(MAT_DIALOG_DATA) public data: StatusDialogData) {}
  toggle(event){
    this.clicked=!this.clicked;
  }
  onNoClick(): void {
    this.dialogRef.close();
    }
  }
